import ComponentManager from '@/Management/ComponentManager';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import ButtonViewModelBuilder from '@/Builder/ButtonViewModelBuilder';
import Utilities from '@/Utility/Utilities';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import RADApplication from '@/Management/RADApplication';
import { ITwoFactorAuthQRCheckBoxViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import NavigationService from '@/Management/NavigationService';
import TwoFactorTokenDialogWindowViewModel from '@/Components/TwoFaktorAuth/TokenDialog/TwoFactorTokenDialogWindowViewModel';

/**
 * Bildet die Komponente ab, welche bspw. innerhalb der Useranlage zu finden ist
 */
export default class TwoFactorAuthQRCheckBoxViewModel extends CheckBoxViewModel {
    public useTwoFAButton: ButtonViewModel;

    public qrCodeWindow: TwoFactorTokenDialogWindowViewModel;

    private context: DetailViewContext;

    /**
     * Das ViewModel für die CheckBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: ITwoFactorAuthQRCheckBoxViewModelConstructorParameter) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);

        this.useTwoFAButton = this.createButtonViewModel();
    }
    private createButtonViewModel(): ButtonViewModel {
        return new ButtonViewModelBuilder()
            .withOnClick(
                () => {
                    let userName = this.context.genericObject.getObservable("Username")();
                    let surName = this.context.genericObject.getObservable("Vorname")();
                    let lastName = this.context.genericObject.getObservable("Nachname")();

                    if (Utilities.isBlank(userName) || Utilities.isBlank(surName) || Utilities.isBlank(lastName)) {
                        RADApplication.getInstance().showMessageBox(MessageBoxViewModel.createNoticeMessageBox('', 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_QR_INVALID_MESSAGE'));
                    } else {
                        let viewFactory = NavigationService.getInstance().loadViewFactoryIsolated('TwoFactorPopupView', {
                            ...this.create2FAWindowParameter(userName, surName, lastName),
                            onClose: () => {
                                NavigationService.getInstance().removeViewFactoryIsolated(viewFactory);
                                viewFactory = null;
                            }
                        }, true);
                    }
                }
        )
            .withIsVisible(this.isChecked)
            .withIsEnabled(!this.context.isLocked())
            .withLocator('show-qrcode')
            .withParentLocator(this.locator)
            .withLabel().withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_SHOW_QR_CODE').done()
        .build()
    }

    private create2FAWindowParameter(userName: string, surName: string, lastName: string): any {
        return {
            userName: userName,
            surAndLastname: surName + " " + lastName,
            tooltip: undefined,
            parentLocator: this.locator,
            locator: 'view'
        }
    }
}

ComponentManager.setViewModel('TwoFactorAuthQRCheckBoxViewModel', TwoFactorAuthQRCheckBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');